/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Compliance status (placeholder - use ComplianceFlags) */
export type ComplianceStatus = {
  /** Status code */
  status: number;
};

export type ComplianceStatusArgs = {
  /** Status code */
  status: number;
};

export function getComplianceStatusEncoder(): Encoder<ComplianceStatusArgs> {
  return getStructEncoder([
    ["status", getU8Encoder()],
  ]);
}

export function getComplianceStatusDecoder(): Decoder<ComplianceStatus> {
  return getStructDecoder([
    ["status", getU8Decoder()],
  ]);
}

export function getComplianceStatusCodec(): Codec<ComplianceStatusArgs, ComplianceStatus> {
  return combineCodec(getComplianceStatusEncoder(), getComplianceStatusDecoder());
}
